export function isDemoOrStagingHost(hostname: string | null | undefined): boolean {
  const normalized = (hostname ?? '').trim().toLowerCase();
  if (!normalized) return false;
  return (
    normalized === 'demo.statura.care' ||
    normalized === 'familydemo.statura.care' ||
    normalized.includes('staging')
  );
}

export function currentHostIsDemoOrStaging(): boolean {
  if (typeof window === 'undefined') return false;
  return isDemoOrStagingHost(window.location.hostname);
}
